import { render, staticRenderFns } from "./EditClinicianReferralDetails.vue?vue&type=template&id=3ceedc93&"
import script from "./EditClinicianReferralDetails.vue?vue&type=script&lang=js&"
export * from "./EditClinicianReferralDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditClinicianReferralDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports